var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoppelseite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Doppelseite__Icn/40px/Doppelseite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0015157,9 L29.150778,9.00548574 C30.1856379,9.08183488 31.0015157,9.9456382 31.0015157,11 L31.0015157,24 L30.99603,24.1492623 C30.9233165,25.1348432 30.1363589,25.9218008 29.150778,25.9945143 L29.1225157,25.995 L20.609,28.814 L20,29.0236337 L19.348,28.8 L10.879,25.995 L10.8507377,25.9945143 C9.86515683,25.9218008 9.0781992,25.1348432 9.00548574,24.1492623 L9,24 L9,11 C9,9.9456382 9.81587779,9.08183488 10.8507377,9.00548574 L11,9 L11.1961161,9.01941932 L20.001,11.954 L28.8053996,9.01941932 L29.0015157,9 Z M29.0015157,11.019 L20.944,13.729 L20.944,26.614 L28.8053996,24.0194193 L29.0015157,24 L29.0015157,11.019 Z M11,11.019 L11,24 L11.1961161,24.0194193 L19.055,26.613 L19.055,13.728 L11,11.019 Z",
    id: ".._.._src_svg_Icn_40px_Doppelseite__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoppelseite);
export default __webpack_public_path__ + "static/media/Doppelseite.519c7a423e8c88e0e10d8e449e0adff3.svg";
export { ForwardRef as ReactComponent };